import { useParams } from "react-router"
import { ProspectTitle } from "@components/ProspectNew/ProspectTitle"
import { ProspectLeftSection } from "@components/ProspectNew/ProspectLeftSection"
import { ProspectCenterSection } from "@components/ProspectNew/ProspectCenterSection"
import { ProspectRightSection } from "@components/ProspectNew/ProspectRightSection"

export const ProspectPage = () => {
  const { prospect_guid } = useParams() as { prospect_guid: string }

  return (
    <div className="tw:flex tw:flex-col tw:gap-4">
      <ProspectTitle prospect_guid={prospect_guid} />
      <div className="tw:grid tw:grid-cols-12 tw:gap-x-2 tw:gap-y-4">
        <div className="tw:col-span-12">
          <ProspectLeftSection prospect_guid={prospect_guid} />
        </div>

        <div className="tw:col-span-12 tw:md:col-span-8">
          <ProspectCenterSection prospect_guid={prospect_guid} />
        </div>
        <div className="tw:col-span-12 tw:md:col-span-4">
          <ProspectRightSection prospect_guid={prospect_guid} />
        </div>
      </div>
    </div>
  )
}
